import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  AdaptiveScanningEnabledBodySchema,
  AdaptiveScanningPauseBodySchema,
  AdaptiveScanningPolicyConfigSchema,
  AdaptiveScanningResumeBodySchema,
  AdaptiveScanningStateSchema,
  AdaptiveScanningWaveResultSchema,
} from './adaptive-scanning.schema';

export const adaptiveScanningContractRoutes = {
  getAdaptiveScanningState: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/adaptive-scanning',
      summary: 'Get adaptive scanning state',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(AdaptiveScanningStateSchema),
  resumeAdaptiveScanning: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/adaptive-scanning/resume',
      summary: 'Resume adaptive scanning after a target block',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: AdaptiveScanningResumeBodySchema,
      }),
    )
    .output(AdaptiveScanningWaveResultSchema),
  pauseAdaptiveScanning: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/adaptive-scanning/pause',
      summary: 'Pause adaptive scanning',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: AdaptiveScanningPauseBodySchema.optional(),
      }),
    )
    .output(AdaptiveScanningStateSchema),
  setAdaptiveScanningEnabled: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'PATCH',
      path: '/{id}/adaptive-scanning',
      summary: 'Enable or disable adaptive scanning for an application',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: AdaptiveScanningEnabledBodySchema,
      }),
    )
    .output(AdaptiveScanningStateSchema),
  updateAdaptiveScanningConfig: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'PATCH',
      path: '/{id}/adaptive-scanning/config',
      summary: 'Update adaptive scanning policy configuration',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        body: AdaptiveScanningPolicyConfigSchema,
      }),
    )
    .output(AdaptiveScanningStateSchema),
  runAdaptiveScanningWave: terraContract
    .meta({
      permissions: [PERMISSIONS.EXECUTE_TESTS.name],
    })
    .route({
      method: 'POST',
      path: '/{id}/adaptive-scanning/run-wave',
      summary: 'Plan and trigger the next adaptive scanning wave',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(AdaptiveScanningWaveResultSchema),
};
